query GetWhatsAppIntegration {
    whatsAppIntegration {
        hasAuthToken
        isEnabled
        userPhoneNumber
        isOnBusinessApp
        contactSync {
            status
            error
        }
        messageSync {
            status
            error
        }
        shouldSyncContacts
        shouldSyncMessages
        origin {
            id
        }
    }
}
